import React from 'react';
interface SectionTagProps {
  icon?: string;
  children: React.ReactNode;
  tone?: 'brown' | 'gray';
}
export function SectionTag({
  icon,
  children,
  tone = 'brown'
}: SectionTagProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs sm:text-sm font-semibold uppercase tracking-wider ${tone === 'brown' ? 'border-brown/30 bg-brown/10 text-brown' : 'border-ink/10 bg-ink/5 text-muted'}`} data-id="element-268" data-mp="3no1r6qp7h4lm">
      {icon && <span aria-hidden="true" data-id="element-269" data-mp="kww013ebt08">{icon}</span>}
      {children}
    </span>;
}